export default __webpack_public_path__ + "static/media/level.25be8eef.svg";